import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AnimatedBackground } from "@/components/AnimatedBackground";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-gradient-to-br from-background via-card to-background overflow-hidden">
      <AnimatedBackground opacity={0.15} />
      <div className="relative z-10 text-center space-y-6 p-8">
        <div className="flex justify-center mb-6">
          <img 
            src="/logo/debtnet-static.png" 
            alt="DebtNet logo" 
            className="h-20 w-auto"
          />
        </div>
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/" className="text-primary underline hover:text-primary/80">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
